import React, {ReactNode, useState} from 'react';
import Page, {PageType} from '@episerver/spa-core/Page';
import CellcomPdfViewPageData from '../../Models/Content/CellcomPdfViewPageData';
import Config from '../../Config';
import './CellcomPdfViewPage.scss';
import {isMobile} from 'react-device-detect';

export default class CellcomPdfViewPage extends Page<CellcomPdfViewPageData> {
  protected pageType = PageType.Other;

  public componentWillMount() {
    console.log('is mobile', isMobile);
    if (!isMobile) {
      window.location.replace(Config.epiBaseUrl + this.props.data.fileLink?.value);
    }
  }

  public render(): ReactNode {
    let fileUrl = `${Config.epiBaseUrl + this.props.data.fileLink?.value}`;

    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    return (
      <div className='CellcomPdfViewer'>
        <iframe src={fileUrl} style={{width: '100%', height: '100vh', border: 'none'}} />
      </div>
    );
  }
}
